<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h1 class="headline">Devotional Completion Ranks</h1>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="ranks"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.title }}</td>
                <td>{{ props.item.requirement }}</td>
                <td>
                  <v-icon small @click="editRank(props.item)">edit</v-icon>
                  <v-icon small @click="deleteRank(props.item)">delete_forever</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn to="/admin/devotional-completion-ranks/new">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    ranks: [],
    pagination: {
      sortBy: 'requirement'
    },
    headers: [
      { text: 'Title', value: 'title' },
      { text: 'Requirement', value: 'requirement' },
      { text: 'Actions', value: 'firstName' } // no actual value
    ]
  }),
  mounted: function () {
    // Populate our data
    this.axios.get('/devotionals/completions/ranks')
      .then((res) => {
        this.ranks = res.data
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    editRank: function (r) {
      this.$router.push('/admin/devotional-completion-ranks/' + r.id)
    },
    deleteRank: function (r) {
      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      confirm('Do you want to remove this item?') &&
      this.axios.delete('/devotionals/completions/ranks/' + r.id)
        .then(() => {
          // Find the index of our rank so we can update the UI immediately
          let index = null
          for (let i in this.ranks) {
            if (this.ranks[i].id === r.id) {
              index = i
              break
            }
          }
          if (index !== null) {
            // Remove the proper row from the list
            this.ranks.splice(index, 1)
          } else {
            this.errMessage = 'An error occurred. Please try again.'
            this.isError = true
          }

          // Send a request to update our cached information for the next time
          // we load the page
          this.axios.get('/devotionals/completions/ranks')
            .catch(() => { /* swallow error */ })
        })
        .catch(this.$root.apiErrorHandler((msg) => {
          this.errMessage = msg
          this.isError = true
        }))
    }
  }
}
</script>
